/* eslint-disable react/no-array-index-key */
import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./productCategories.scss";

const SkeletonProductCategories: FC<PropsWithClasses> = ({ classes = {} }) => {
  return (
    <div className={classes.categories}>
      {Array(5)
        .fill(undefined)
        .map((item, index) => (
          <Skeleton className={classes.categoryItem} key={index} />
        ))}
    </div>
  );
};

export default classify<PropsWithClasses>(defaultClasses)(
  SkeletonProductCategories
);
